export default __webpack_public_path__ + "static/media/india rating newsroom inner page.ef7d6a8f.jpg";